export default __webpack_public_path__ + "ClanOT-Thin.otf";